import { LogRequest, LogLevel } from "./types/index";
import { resolveAppUrl } from "./app-url-client";

function buildMessage(message: string, data: any[]): string {
    if (!data || data.length === 0) return message;

    const parts = data.map((d) => {
        if (d instanceof Error) {
            return d.stack ?? d.message;
        }

        if (typeof d === "string") return d;

        try {
            return JSON.stringify(d);
        } catch {
            return String(d);
        }
    });

    return `${message} | data: ${parts.join(" | ")}`;
}


export function info(message: string, ...data: any[]): void {
    const request: LogRequest = {
        level: LogLevel.Info,
        message: buildMessage(message, data)
    };

    console.info(message, ...data);
    sendLog(request);
}

export function warn(message: string, ...data: any[]): void {
    const request: LogRequest = {
        level: LogLevel.Warn,
        message: buildMessage(message, data)
    };

    console.warn(message, data);
    sendLog(request);
}

export function error(message: string, ...data: any[]): void {
    const request: LogRequest = {
        level: LogLevel.Error,
        message: buildMessage(message, data)
    };

    console.error(message, data);
    sendLog(request);
}

function sendLog(request: LogRequest): void {
    // CA-1567: was a bare root-relative $.ajax URL, which drops the PathBase prefix under a
    // non-root PathBase -- every client error report from the deployed box was silently
    // 404ing before this fix.
    $.ajax(resolveAppUrl("/log"), {
        method: "POST",
        data: JSON.stringify(request),
        headers: {
            "Content-Type": "application/json"
        }
    });
}

type ClientLog = {
    warn: typeof warn,
    info: typeof info,
    error: typeof error
}

const clientLog: ClientLog = {
    warn: warn,
    info: info,
    error: error
}

globalThis.ClientLog = clientLog;

window.ClientLog = clientLog || {};

window.addEventListener("error", (event) => {
    try {
        const message =
            event?.error?.message ||
            event?.message ||
            "Unknown window error";

        const stack = event?.error?.stack || null;

        ClientLog.error(message, stack);
    } catch (ex) {
        console.log("error handler failed:", ex, event);
    }
});

window.addEventListener("unhandledrejection", (event) => {
    try {
        const reason = event?.reason;
        const message = reason?.message || String(reason || "Unknown rejection");
        const stack = reason?.stack || null;

        ClientLog.error(message, stack);
    } catch (ex) {
        console.log("unhandledrejection handler failed:", ex, event);
    }
});